import { Avatar, Typography } from '@loophealth/loop-ui-web-library';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FirebaseAuth } from '../../../adapters/provider';
import { DropdownIcon } from '../../../assets/img';
import { resetState as resetEnrolmentData } from '../../../redux/slices/EnrolmentSlice';
import { resetModularState } from '../../../redux/slices/ModularEnrolmentSlice';
import { resetState as resetPolicyData } from '../../../redux/slices/PolicyListSlice';
import { capitalizeFirstLetter } from '../../../utils/common';
import { INTERNAL_ROUTES, MAIN_ROUTES } from '../../../utils/constants';
import { SEGMENT_ACTIONS } from '../../../utils/constants/SegmentActionConstants';
import useSegment from '../../../utils/hooks/useSegment';
import { logoutUser } from '../../pages/LoginContainer/redux/slices/UserSlice';
import { selectUserData } from '../../pages/LoginContainer/redux/slices/UserSlice/selectors';
import {
    StyledChevronIcon,
    StyledLoopTopRightEdgeContainer,
    StyledLoopTopRightUserMenuContainer,
    StyledProfileDropdownContainer,
    StyledProfileDropdownItem,
    StyledProfileDropdownItems,
    StyledTopRightAvatarContent,
    StyledTopRightAvatarContentText,
    StyledTopRightAvatarWrapper
} from './styles';

interface ILoopTopRightUserMenuProps {
    showDashboard?: boolean;
}

const LoopTopRightUserMenu: React.FC<ILoopTopRightUserMenuProps> = ({ showDashboard }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const trackClick = useSegment('click');
    const trackLogout = useSegment('identify');
    const userData = useSelector(selectUserData);
    const userName = userData.data?.firstName || '';
    const [isProfileDropdownOpen, setIsProfileDropdownOpen] = React.useState(false);

    const toggleProfileIcon = () => setIsProfileDropdownOpen(!isProfileDropdownOpen);

    const logout = () => {
        trackClick(SEGMENT_ACTIONS.CLICK.NAVIGATION_HEADER_SIGNOUT);
        FirebaseAuth.signOut();
        trackLogout({
            name: SEGMENT_ACTIONS.IDENTIFY.USER_LOGOUT.name
        });
        dispatch(resetEnrolmentData());
        dispatch(logoutUser());
        dispatch(resetPolicyData());
        dispatch(resetModularState());
        toggleProfileIcon();
        history.replace(MAIN_ROUTES.login, { hideBanner: true });
    };

    const redirectToDashboard = () => {
        const segmentAction = SEGMENT_ACTIONS.CLICK.NAVIGATION_HEADER_LOGO;
        trackClick({
            name: segmentAction.name,
            properties: {
                describe: segmentAction.properties?.describe,
                page_title: segmentAction.properties?.page_title,
                login_status: segmentAction.properties?.login_status
            }
        });
        history.push(INTERNAL_ROUTES.dashboard, { previousUrl: location.pathname });
    };

    return (
        <StyledLoopTopRightUserMenuContainer key="loop-top-right-user-menu">
            <StyledLoopTopRightEdgeContainer />
            <StyledTopRightAvatarWrapper>
                <StyledTopRightAvatarContent onClick={toggleProfileIcon}>
                    <StyledTopRightAvatarContentText>
                        <Avatar users={[{ name: userName, imageURL: '' }]} />
                        <Typography variant="small" weight="medium">
                            {capitalizeFirstLetter(userName)}
                        </Typography>
                    </StyledTopRightAvatarContentText>
                    <StyledChevronIcon src={DropdownIcon} $flip={isProfileDropdownOpen} />
                </StyledTopRightAvatarContent>
                {isProfileDropdownOpen && (
                    <StyledProfileDropdownContainer data-testid="profile-dropdown">
                        <StyledProfileDropdownItems>
                            {showDashboard && (
                                <StyledProfileDropdownItem onClick={redirectToDashboard}>
                                    <Typography variant="small">Back to Dashboard</Typography>
                                </StyledProfileDropdownItem>
                            )}
                            <StyledProfileDropdownItem onClick={logout}>
                                <Typography variant="small">Sign Out</Typography>
                            </StyledProfileDropdownItem>
                        </StyledProfileDropdownItems>
                    </StyledProfileDropdownContainer>
                )}
            </StyledTopRightAvatarWrapper>
        </StyledLoopTopRightUserMenuContainer>
    );
};

export default LoopTopRightUserMenu;
